export default __webpack_public_path__ + "static/media/12.2e949a37.jpg";